import { mapState } from "pinia";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";

// ContactUsPage element host. Previously consumed
// `~/stores/user-store` (outside the editor directory tree) for the
// applicant computeds. Surface them off the example entity instead
// to honour the editor's isolation rule.
export const ContactUsPageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  computed: {
    ...mapState(useGeneralStore, [
      "userId",
    ]),
    ...mapState(useConfigurationStore, [
      "isSignupAndLoginEnabled",
    ]),
    loggedInEmail() {
      return this.entity?.email ?? "user@example.com";
    },
    loggedInFirstName() {
      return this.entity?.firstName ?? "User";
    },
    loggedInLastName() {
      return this.entity?.lastName ?? "Visitor";
    },
    isUserLoggedIn() {
      return this.isSignupAndLoginEnabled && this.userId > 0;
    },
  },
  methods: {
    getExampleEntity() {
      return {
        firstName: "User",
        lastName: "Visitor",
        email: "user@example.com",
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
